import * as React from 'react';
import cx from 'classnames';
import DatePicker from 'react-datepicker';

const DatePickerField = (props) => {
  const {
    field,
    form: { touched, errors, setFieldValue, setFieldTouched },
    label,
    className,
    placeholder,
    dateFormat,
    cbChange,
    ...rest
  } = props;

  const handleOnBlur = (e) => {
    setFieldTouched(field.name)
  };

  const onChange = (value) => {
    setFieldValue(field.name, value);

    if (cbChange) {
      cbChange(field, value);
    }
  };

  const cn = cx(className || 'input', {
    'input--err': errors[field.name],
    'input--touched': field.value,
  });

  return (
    <div className={cn}>
      <DatePicker
        name={field.name}
        placeholderText={placeholder || label}
        selected={(field.value && new Date(field.value)) || null}
        dateFormat={dateFormat}
        onChange={onChange}
        onBlur={handleOnBlur}
        popperPlacement="bottom-end"
        {...rest}
      />
      {label && <label className="input__lbl">{label}</label>}
      {touched[field.name] && errors[field.name] && <span className="input--err__msg">{errors[field.name]}</span>}
    </div>
  );
};

export default DatePickerField;
